import { render, staticRenderFns } from "./BudgetControllership.vue?vue&type=template&id=07d15fbb"
import script from "./BudgetControllership.vue?vue&type=script&lang=js"
export * from "./BudgetControllership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports